import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='container'>
            <div className='.row'>
                <div className='col-lg-8 mx-auto my-5'>
                    {/* ---------------------  */}

                    <h3>Privacy Policy for <span className=' text-info'> smart cleaner </span> </h3>

                    <p>At  smart cleaner, accessible from https://a-smart-cleaner.web.app/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by  smart cleaner and how we use it.</p>

                    <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>

                    <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in  smart cleaner. </p>

                    <h5>Consent</h5>

                    <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>

                    <h5>Third Party Privacy Policies</h5>

                    <p> smart cleaner's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. </p>

                    <p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>


                    {/* ---------------------  */}
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;